import React from 'react';

export const GreenCheck = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.24911 13.4334L6.81661 11.0009L5.98828 11.8234L9.24911 15.0842L16.2491 8.08422L15.4266 7.26172L9.24911 13.4334Z"
        fill="#138846"
      />
    </svg>
  );
};
